export default __webpack_public_path__ + "static/media/osu.04a7bd3f.svg";